module.exports = __webpack_public_path__ + "img/mission.bb2e794.svg";